import { render } from "./AustraliaSmartOnboardingDownload.vue?vue&type=template&id=3de581f3"
import script from "./AustraliaSmartOnboardingDownload.vue?vue&type=script&lang=js"
export * from "./AustraliaSmartOnboardingDownload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__